/**
 * Analytics metric formatting helpers (§26.2). A metric with no data arrives as `null` (missing) and
 * MUST be rendered as "—" — never coerced to `0`, which would misrepresent absence as a real zero.
 */

/** Em dash shown for a missing metric. */
export const MISSING = '—';

/** Format a nullable count: `null` → "—", otherwise the localised integer. */
export function formatMetric(value: number | null | undefined): string {
  if (value === null || value === undefined) return MISSING;
  return value.toLocaleString();
}

/** Format a nullable rate (0..1) as a percentage: `null` → "—", otherwise e.g. `0.42` → "42%". */
export function formatRate(rate: number | null | undefined): string {
  if (rate === null || rate === undefined) return MISSING;
  return `${(rate * 100).toFixed(1)}%`;
}
